/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import Spinner from '@atlaskit/spinner';
import React, { useEffect } from 'react';

import { Icon, IconCloseSched } from '../../../base/icons';

interface AddExistedContactsModalProps {
    onClose?: () => void,
    isLoading?: boolean,
    selectedUserList?: Array,

    handleSubmitAddExistedContacts?: Function,
    addContactList?: Array
}
const AddExistedContactsModal = (props: AddExistedContactsModalProps) => {
    const { onClose = () => {}, isLoading, selectedUserList = [], handleSubmitAddExistedContacts, addContactList } = props;
    const [ contacts, setContacts ] = React.useState(selectedUserList);

    useEffect(() => {
        setContacts(selectedUserList);
    }, [ selectedUserList ]);

    const handleClose = () => {
        onClose();
    };

    const handleToggle = item => {
        const raw = [ ...contacts ];

        contacts.map((re, index) => {
            if (re.id === item.id) {
                const selectContact = { ...re,
                    isContact: !re.isContact };

                raw.splice(index, 1, selectContact);
                setContacts(raw);
            }
        });
    };

    const handleSubmit = () => {
        handleSubmitAddExistedContacts(contacts);
        onClose();
    };
    const defaultAvatarUser = 'https://dev.pantherconnect.me/images/gen-avatar.jpg';
    const defaultAvatarGroup = 'https://ui-avatars.com/api/?uppercase=true&name=Group+Call&background=494B4C&color=ffffff&size=48&font-size=0.3';

    const renderItems = () => contacts?.filter(contact => !addContactList?.find(e => e.id === contact.id))?.map((item, index) => (
        <div
            className = { 'add-existed-contacts-modal--label-list' }
            key = { index }>
            <div className = 'add-existed-contacts-modal--label-list--item'>
                <img
                    alt = 'image'
                    className = 'add-existed-contacts-modal--label-list--avatar'
                    height = '48'
                    src = { item.isGroup ? defaultAvatarGroup : item?.avatar ?? defaultAvatarUser }
                    width = '48' />
                <p className = { 'add-existed-contacts-modal--label-list--font-style' }>{item.name}</p>
            </div>
            <div
                className = { 'add-existed-contacts-modal--label-list--remove' }>
                <button
                    className = 'o-phone-book-item-btn'
                    onClick = { () => handleToggle(item, index) }>
                    {
                        item?.isContact
                            ? <div className = 'o-phone-book-item-dot black-dot' />
                            : null
                    }
                </button>
            </div>
        </div>
    ));

    return (
        <div className = 'add-existed-contacts-modal__wrapper' >
            <div className = 'add-existed-contacts-modal__background' />
            <div className = 'add-existed-contacts-modal__container' >
                <div className = { 'add-existed-contacts-modal' }>
                    <div className = { 'add-existed-contacts-modal--w-100' }>
                        <Icon
                            className = { 'add-existed-contacts-modal--close' }
                            onClick = { handleClose }
                            size = { 31 }
                            src = { IconCloseSched } />
                    </div>
                    <div className = { 'add-existed-contacts-modal--title' }>
                        add contact
                    </div>
                    <div className = { 'add-existed-contacts-modal--list-items' }>
                        {renderItems()}
                    </div>

                    <div className = { 'add-existed-contacts-modal--buttons' }>
                        <div
                            className = { 'add-existed-contacts-modal--cancel' }
                            onClick = { handleClose }>
                            cancel
                        </div>
                        <div
                            className = { 'add-existed-contacts-modal--save' }
                            onClick = { handleSubmit }>
                            {isLoading ? <Spinner /> : 'save'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddExistedContactsModal;
